import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import { localImages } from '../../../../constants/app-config';
import {CustomTemplateService} from "../../services/custom-template.service";
import {InvoicesService} from "../../services/invoices.service";
import {FolderService} from "../../services/folder.service";
import { log } from 'console';

@Component({
  selector: 'app-custom-templates',
  templateUrl: './custom-templates.component.html',
  styleUrls: ['./custom-templates.component.css']
})
export class CustomTemplatesComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<CustomTemplatesComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              public customTemplateService: CustomTemplateService,
              public invoiceService: InvoicesService,
              public folderService: FolderService,
              ) {
  }

  localImages = localImages
  @ViewChild('inputWrapper') inputWrapper: any
  inputs = this.customTemplateService.inputs
  imageIndex = 0;

  ngOnInit(): void {
    if (this.data) {
      this.data?.forEach((el: any, index: any, array: any) => {
        el.index = index;
        el.inputs = [];
        if (el.extractedResults) {
          const extractedResults = JSON.parse(el.extractedResults);
          for (const [key, value] of Object.entries(extractedResults)) {
            el.inputs.push({value: value, heading: key});
          }
        }
        if (el.missingFields) {
          el.missingFields.forEach((field: any) => {
            el.inputs.push({value: '', heading: field})
          })
        }
      });
    }
  }

  async changeStep(value: any): Promise<void> {
    let nextStep = this.data.find((slide: any) => slide.index == value.index + 1);
    let currentStep = this.data.find((slide: any) => slide.index == value.index);
    let refactoredExtractedResults: any = {};
    let isStepCompleted = true
    currentStep.inputs.forEach((input: any) => {
      refactoredExtractedResults[input.heading] = input.value
    });
    currentStep.extractedResults = JSON.stringify(refactoredExtractedResults)
    currentStep.inputs.forEach((input: any) => {
      if (input.value.trim().length === 0) {
        isStepCompleted = false
      }
    })
    if (isStepCompleted) {
      const updatedInvoice = {
        id: currentStep.id,
        extractedResults: currentStep.extractedResults,
        missingFields: '[]'
      }
      this.data = this.data.filter((el: any) => el.id !== currentStep.id)
      this.data.forEach((el: any, index: any) => {
        el.index = index;
      })
      await this.invoiceService.UpdateInvoice(updatedInvoice).catch(err => console.log(err))
    }
    if (nextStep) {
      this.imageIndex = nextStep.index;
    }
    else {
      this.imageIndex = this.data[0].index;
    }
  }

  async skipAndDownload() {
    if (this.data.length === 1) {
      let isFinalInvoiceCompleted = true;
      this.data[0].inputs.forEach((input: any) => {
        if (input.value.trim().length === 0) {
          isFinalInvoiceCompleted = false;
        }
      })
      if (isFinalInvoiceCompleted) {
        const stringifiedValue = JSON.parse(JSON.stringify(this.data[0]))
        stringifiedValue.extractedResults = JSON.parse(stringifiedValue.extractedResults)
        let refactoredExtractedResults: any = {};
        stringifiedValue.inputs.forEach((input: any) => {
          refactoredExtractedResults[input.heading] = input.value
        });
        const updatedInvoice = {
          id: this.data[0].id,
          extractedResults: JSON.stringify(refactoredExtractedResults),
          missingFields: '[]'
        }
        await this.invoiceService.UpdateInvoice(updatedInvoice).catch(err => console.log(err))
          .then(async () => {
            const updatedFolder = {
              id: this.data[0].folderID,
              areThereMissingFields: false
            }
            await this.folderService.UpdateFolder(updatedFolder).then((data: any) => {
              this.dialogRef.close({event: 'skipAndDownload'})
            }).catch((err) => console.log(err));
          })
      }
    }
    this.dialogRef.close({event: 'skipAndDownload'})
  }

  isNextDisabled(data: any): boolean {
    let isDisabled = false;
    return isDisabled;
  }

  openDocumentEmitter(event: any, eventName: any) {
    if (event) {
      window.open(eventName)
    }
  }

  getSingularOrPlural(length:number){
   return length > 1 ? 'racuna imaju' : 'racun ima'
  }
}
